import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";

export interface ItemDescriptionProps extends HTMLAttributes<HTMLParagraphElement> {
  ref?: Ref<HTMLParagraphElement>;
}

export const ItemDescription = ({ className, ref, ...props }: ItemDescriptionProps) => (
  <p
    ref={ref}
    data-slot="item-description"
    className={cn(
      "line-clamp-2 text-balance text-sm font-normal leading-normal text-muted-foreground",
      "[&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-accent",
      className,
    )}
    {...props}
  />
);
